export const header_components_desktop = [
  {
    type: "HeaderLink",
    label: "Aufträge finden",
    link: "/ausschreibungsdienste",
  },
  {
    type: "HeaderLink",
    label: "Aufträge vergeben",
    link: "/evergabe",
  },
  {
    type: "HeaderLink",
    label: "Vergabe-Wissen",
    link: "/vergabe-wissen",
  },
  {
    type: "HeaderDropdown",
    label: "Fachzeitschriften",
    link: "/fachzeitschriften",
    dropdown_menu_items: [
      {
        type: "HeaderDropdownLink",
        link: "/fachzeitschriften/baumagazin",
        magazine: "baumagazin",
        title: "B_I baumagazin",
      },
      {
        type: "HeaderDropdownLink",
        link: "/fachzeitschriften/galabau",
        magazine: "galabau",
        title: "B_I galabau",
      },
      {
        type: "HeaderDropdownLink",
        link: "/fachzeitschriften/umweltbau",
        magazine: "umweltbau",
        title: "B_I umweltbau",
      },
    ],
  },
  {
    type: "HeaderLink",
    label: "Über uns",
    link: "/ueber-uns",
  },
  {
    type: "HeaderLoginButton",
    label: "Login",
    link: "/login",
    dropdown_menu_items: [
      {
        type: "LoginDropdownLink",
        href: "https://auftragnehmer.bi-medien.de/de/home",
        label: "Auftragnehmer",
      },
      {
        type: "LoginDropdownLink",
        href: "https://evergabe.bi-medien.de",
        label: "Auftraggeber",
      },
    ],
  },
  {
    type: "HeaderInternalSearchButton",
    label: "search",
    link: "search",
    mobile: false,
  },
]
